import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { resetPasswordForUser } from "../../redux/slices/authSlice";
import { IconBrandFacebook, IconBrandTwitter, IconBrandLinkedin, IconBrandInstagram, IconBrandYoutube } from "@tabler/icons-react";
import {
  IconArrowRight,
  IconLock
} from "@tabler/icons-react";
import Logo from "../../assets/images/paqtory.png";
import LoginImage from "../../assets/images/login.jpg";

export default function ResetPassword() {
  const { token } = useParams();
  // const token = searchParams.get('token');
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError("Passwords don't match");
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const result = await dispatch(resetPasswordForUser({ token, password }));
      if (result.error) {
        const error = result.payload.message || "An error occurred during password reset or request new password link \n navigate to login page > forget password";
        setError(error);
        return;
      }
      setSuccess(true);
    } catch (err) {
      setError(err.message || "An error occurred during password reset");
    } finally {
      setIsLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen flex flex-col bg-[#F9F9FF]">
        <header className="h-16 bg-[#0B0C52] flex items-center justify-between px-4 md:px-8 text-white">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <div className="w-10 h-10 rounded-full bg-[#FFD500] flex items-center justify-center">
                <img src={Logo} alt="Logo" className="w-6 h-6 object-contain" />
              </div>
              <span className="ml-2 text-sm font-semibold">Logo</span>
            </Link>
          </div>
          <div>
            <button className="border border-white px-3 py-1 rounded-md text-sm flex items-center gap-1 hover:bg-white hover:text-[#0B0C52] transition-colors">
              English <span className="text-xs">&#x25BE;</span>
            </button>
          </div>
        </header>

        <main className="flex-1 flex items-center justify-center px-4 py-8">
          <div className="max-w-md w-full bg-white rounded-md border border-[#FFD500]/30 p-8 text-center" style={{ boxShadow: "0 0 0 2px #FFD500" }}>
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-10 h-10 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <h2 className="text-2xl font-bold mb-4 text-[#0B0C52]">Password Reset Successful!</h2>
            <p className="text-gray-600 mb-6">
              Your password has been successfully updated. You can now login with your new password.
            </p>
            <button
              onClick={() => navigate("/login")}
              className="bg-[#0B0C52] text-white px-6 py-2 rounded text-sm font-semibold hover:opacity-90"
            >
              Back to Login
            </button>
          </div>
        </main>

        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-[#F9F9FF]">
      <header className="h-16 bg-[#0B0C52] flex items-center justify-between px-4 md:px-8 text-white">
        <div className="flex items-center">
          <Link to="/" className="flex items-center">
            <div className="w-10 h-10 rounded-full bg-[#FFD500] flex items-center justify-center">
              <img src={Logo} alt="Logo" className="w-6 h-6 object-contain" />
            </div>
            <span className="ml-2 text-sm font-semibold">Logo</span>
          </Link>
        </div>
        <div>
          <button className="border border-white px-3 py-1 rounded-md text-sm flex items-center gap-1 hover:bg-white hover:text-[#0B0C52] transition-colors">
            English <span className="text-xs">&#x25BE;</span>
          </button>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 py-8">
        <div className="max-w-5xl w-full flex flex-col lg:flex-row items-center gap-8">
          <div className="flex justify-center lg:w-1/2">
            <img src={LoginImage} alt="Reset Password" className="max-w-sm w-full h-auto object-cover rounded-md shadow" />
          </div>

          <div className="lg:w-1/2 flex justify-center">
            <form onSubmit={handleSubmit} className="max-w-sm w-full bg-white rounded-md border border-[#FFD500]/30 p-6" style={{ boxShadow: "0 0 0 2px #FFD500" }}>
              <div className="w-12 h-12 bg-[#FFD500]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <IconLock size={24} className="text-[#0B0C52]" />
              </div>
              <h2 className="text-2xl font-bold mb-2 text-center text-[#0B0C52]">Reset Your Password</h2>
              <p className="text-sm text-gray-600 text-center mb-6">Enter your new password below</p>

              {error && (
                <div className="mb-4 text-red-500 text-sm text-center">
                  {error}
                </div>
              )}

              {!token && (
                <div className="mb-4 text-red-500 text-sm text-center">
                  Invalid or missing reset token
                </div>
              )}

              <div className="mb-4">
                <label className="block text-sm font-semibold mb-1">New Password</label>
                <input
                  type="password"
                  placeholder="Enter your new password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className={`w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#0B0C52] ${isLoading ? "bg-gray-100 cursor-not-allowed" : ""
                    }`}
                  required
                  disabled={isLoading || !token}
                  minLength={8}
                />
              </div>

              <div className="mb-6">
                <label className="block text-sm font-semibold mb-1">Confirm New Password</label>
                <input
                  type="password"
                  placeholder="Confirm your new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className={`w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#0B0C52] ${isLoading ? "bg-gray-100 cursor-not-allowed" : ""
                    }`}
                  required
                  disabled={isLoading || !token}
                  minLength={8}
                />
              </div>

              <button
                type="submit"
                className="bg-[#FFD500] text-[#0B0C52] w-full py-2 rounded font-semibold flex items-center justify-center gap-2 hover:opacity-90 mb-4 disabled:opacity-70 disabled:cursor-not-allowed"
                disabled={isLoading || !token}
              >
                {isLoading ? (
                  <span className="flex items-center">
                    <svg
                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-[#0B0C52]"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Resetting...
                  </span>
                ) : (
                  <>
                    Reset Password <IconArrowRight size={20} />
                  </>
                )}
              </button>

              <div className="text-center">
                <p className="text-sm mb-2">Remember your password?</p>
                <button
                  type="button"
                  onClick={() => navigate("/login")}
                  className="bg-[#0B0C52] text-white px-6 py-2 rounded text-sm font-semibold hover:opacity-90"
                >
                  Sign In
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}


function Footer() {
  return (
    <footer className="bg-[#0B0C52] border-t border-gray-200 py-6">
      <div className="max-w-5xl mx-auto px-4 flex flex-col items-center space-y-3 text-white">
        <div className="flex flex-wrap justify-center space-x-4 text-sm">
          <a href="#about" className="hover:underline">About Us</a>
          <span>|</span>
          <a href="#terms" className="hover:underline">Terms & Conditions</a>
          <span>|</span>
          <a href="#privacy" className="hover:underline">Privacy Policy</a>
          <span>|</span>
          <a href="#contact" className="hover:underline">Contact Us</a>
          <span>|</span>
          <a href="#faq" className="hover:underline">FAQ</a>
        </div>
        <div className="flex space-x-3">
          <SocialIcon href="#facebook">
            <IconBrandFacebook size={18} />
          </SocialIcon>
          <SocialIcon href="#twitter">
            <IconBrandTwitter size={18} />
          </SocialIcon>
          <SocialIcon href="#linkedin">
            <IconBrandLinkedin size={18} />
          </SocialIcon>
          <SocialIcon href="#instagram">
            <IconBrandInstagram size={18} />
          </SocialIcon>
          <SocialIcon href="#youtube">
            <IconBrandYoutube size={18} />
          </SocialIcon>
        </div>
        <p className="text-sm text-gray-400">© 2025 Company Name. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

function SocialIcon({ href, children }) {
  return (
    <a
      href={href}
      className="w-8 h-8 bg-white border border-[#0B0C52] rounded flex items-center justify-center text-[#0B0C52] hover:bg-[#0B0C52] hover:text-white transition"
    >
      {children}
    </a>
  );
}